import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import ListEvents from "../Components/Events/listEvents";
import ViewEvents from "../Components/Events/viewEvent";
import AddEvents from "../Components/Events/addEvents";
import EditEvents from "../Components/Events/editEvents";

const EventRoutes = () => {
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];

  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  return (
    <Routes>
      <Route path="/event" element={<ListEvents></ListEvents>}></Route>
      <Route path="/event/view/:id" element={<ViewEvents></ViewEvents>}></Route>
      <Route path="/event/add" element={canAdd ? <AddEvents /> : <Navigate to="/event" replace />}></Route>
      <Route path="/event/edit/:id" element={canEdit ? <EditEvents /> : <Navigate to="/event" replace />}></Route>
    </Routes>
  );
};

export default EventRoutes;
